import React from 'react';
import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Text, Icon } from './atoms';

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 30px;
    color: #C2CCCE;

    &:hover {
      color: ${theme?.colour?.secondary};
      i {
        color: ${theme?.colour?.secondary};
      }
    }

    @media only screen and (min-width: 768px) {
      margin-right: 40px;
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Icon',
      displayValue: ({ tab }) => <i className={tab.icon} />,
      displayState: ({ selected }) => ({ selected })
    },
    {
      component: Text,
      name: 'Name',
      displayValue: ({ tab }) => tab.display,
      displayState: ({ selected }) => ({ selected })
    },
  ]
})